isRelAbs